import { ButtonClose } from "../ui"; // Botón reutilizable para cerrar el popup
import { PopupProps } from "@/types"; // Tipos para las props del popup
import { PopupStilosCss } from "../styles"; // Estilos específicos para el popup

/**
 * Componente PopupGenerico
 * 
 * Renderiza un modal emergente genérico centrado en pantalla con fondo semitransparente.
 * Permite mostrar cualquier contenido pasado como children y un botón para cerrar.
 * 
 * @param {PopupProps} props
 * @param {boolean} props.isOpen - Controla si el popup debe mostrarse.
 * @param {() => void} props.onClose - Función que se ejecuta al cerrar el popup.
 * @param {React.ReactNode} props.children - Contenido que se renderiza dentro del popup.
 * @param {string} [props.className] - Clases CSS adicionales opcionales.
 */
const PopupGenerico: React.FC<PopupProps> = ({ isOpen, onClose, children, className }) => {

  // Si isOpen es false, no renderizamos nada
  if (!isOpen) return null;

  return (
    // Contenedor principal del popup
    // fixed: posicionado sobre toda la pantalla
    // inset-0: ocupa todo el ancho y alto de la pantalla
    // flex items-center justify-center: centra el contenido horizontal y verticalmente
    // bg-black bg-opacity-70: fondo negro semitransparente
    // z-50: asegura que esté por encima de otros elementos
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
      
      {/* Contenedor interno del contenido del popup */}
      {/* className + PopupStilosCss.popupPago: aplica estilos personalizados */}
      {/* bg-zinc-400: fondo gris */}
      {/* shadow-xl: sombra grande */}
      {/* rounded-md: bordes redondeados */}
      {/* p-4: padding interno */}
      {/* relative: posición relativa para posicionar elementos absolutos dentro */}
      {/* w-10/12 md:w-6/12: ancho responsivo */}
      {/* max-h-[95vh] overflow-y-auto: limita altura y permite scroll si es necesario */}
      <div className={`${className} ${PopupStilosCss.popupPago}  
        bg-zinc-400 shadow-xl rounded-md p-4 relative w-10/12 md:w-4/12 max-h-[95vh] overflow-y-auto px-14`}>

        {/* Renderiza cualquier contenido pasado al popup */}
        {children}

        {/* Botón de cerrar en la esquina superior derecha */}
        <ButtonClose
          onClick={onClose}
          className="absolute top-2 right-2"
        />
      </div>
    </div>
  );
};

export default PopupGenerico;
